<template>
  <v-dialog v-model="show" max-width="350">
    <v-card>
      <v-alert :type="headerType">{{ title }}</v-alert>

      <v-card-text>
        {{ description }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          outlined
          small
          class="ml-2 primary--text font-weight-bold"
          @click="show = false"
        >
          Close
        </v-btn>

        <v-btn color="error" small @click="onConfirmClick">
          {{ confirmButtonLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    value: Boolean,
    headerType: {
      type: String,
      default: 'warning',
    },
    title: {
      type: String,
      default: 'Warning',
    },
    description: {
      type: String,
      required: true,
    },
    confirmButtonLabel: {
      type: String,
      default: 'Confirm',
    },
    onConfirmClick: Function,
    onCloseClick: Function,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    show(val) {
      if (!val) this.onCloseClick();
    },
  },
};
</script>

<style>
</style>
